import Axios from "axios";
var ShopActivityService = (function () {
    function ShopActivityService() {
    }
    ShopActivityService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/shopping_poster/list", { params: params });
    };
    ShopActivityService.prototype.detail = function (params) {
        return Axios.get("supplierclientapi/shopping_poster/detail", { params: params });
    };
    ShopActivityService.prototype.addPoster = function (params) {
        return Axios.post("supplierclientapi/shopping_poster/create", params);
    };
    ShopActivityService.prototype.configShow = function (params) {
        return Axios.get("supplierclientapi/shoppingconfig/show", { params: params });
    };
    ShopActivityService.prototype.update = function (params) {
        return Axios.post("supplierclientapi/shopping_poster/update", params);
    };
    ShopActivityService.prototype.copy = function (params) {
        return Axios.post("supplierclientapi/shopping_poster/copy", params);
    };
    ShopActivityService.prototype.publish = function (params) {
        return Axios.post("supplierclientapi/shopping_poster/release", params);
    };
    ShopActivityService.prototype.getGoods = function (params) {
        return Axios.post("supplierclientapi/common/goods_list", params);
    };
    ShopActivityService.prototype.getCategory = function (params) {
        return Axios.post("supplierclientapi/suppliergoodstype/type_list", params);
    };
    ShopActivityService.prototype.getActivityList = function (params) {
        return Axios.post("supplierclientapi/shopping_activity/list", params);
    };
    ShopActivityService.prototype.getActTypeList = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/activity_type_option", { params: params });
    };
    ShopActivityService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ShopActivityService;
}());
export default ShopActivityService;
